import {clientStaffRoutes} from '../utils';
import ExpensesTable from '@/views/expenses/ExpensesTable.vue';
import ExpensesCard from '@/views/expenses/ExpensesCard.vue';

export default [
   ...clientStaffRoutes({
      name: 'cloud-table',
      path: '/cloud-table',
      component: ExpensesTable,
      props: {expenseType: 'cloud'},
      stage: 'cloud',
      breadCrumb: [
         {text: 'Dashboard', to: {name: 'Home'}},
         {text: '__COMPANYNAME__', to: {name: 'company-detail', params: {id: 'FILL'}}},
         {text: 'Cloud Computing'},
      ],
   }),
   ...clientStaffRoutes({
      name: 'cloud-period-review',
      path: '/cloud-computing/:periodId/company',
      component: ExpensesCard,
      props: {expenseType: 'cloud'},
      stage: 'cloud',
      breadCrumb: [
         {text: 'Dashboard', to: {name: 'Home'}},
         {text: '__COMPANYNAME__', to: {name: 'company-detail', params: {id: 'FILL'}}},
         {text: 'Cloud Computing', to: {name: 'cloud-table-staff', params: {id: 'FILL'}}},
         {text: 'Cloud Computing - Review'},
      ],
   }),
];
